import { ColumnSort } from '@tanstack/react-table'

export function getSortDirection(sort: ColumnSort | undefined) {
  if (sort === undefined) {
    return 'DESC'
  }

  return sort.desc ? 'DESC' : 'ASC'
}
